<template>
  <div class="select-address">
    <i class="line"></i>
    <van-empty v-if="list.length == 0" image="https://xhdata.wan4.com/wsw-h5-38.png" description="没有收货地址！" />
    <template v-else>
      <div class="item-box" v-for="item, index in list" :key="index">
        <span class="name">{{ item.cname }}/{{ item.cmobile }}</span>
        <span class="address">{{ item.daddr }}{{ item.daddr2 }}</span>
        <span class="default-opt" v-if="item.dflag == 1">默认收货地址</span>
        <i class="icon-edit" @click="edit(item)">编辑</i>
        <i class="selelct-box" :class="{ 'selelct-box-on': selectId == item.seq }" @click="selectId = item.seq">选择</i>
      </div>
      <span class="add-btn" @click="editItem = {}, showEditAddress = true"><i></i>添加收货地址</span>
    </template>
    <!-- 添加 -->
    <div class="bottom-btn-box">
      <van-button class="add-btn" type="primary" @click="setAddress">确定</van-button>
    </div>

    <editAddressPopup v-model="showEditAddress" :data="editItem" @onFinish="getData()"></editAddressPopup>
  </div>
</template>

<script>
import editAddressPopup from '../../components/editAddressPopup.vue';
export default {
  name: 'SelectAddress',
  data() {
    return {
      showEditAddress: false,
      editItem: {},
      list: [],
      selectId: '',
      myData: {},
    }
  },
  created() {
    this.getData();
  },
  components: {
    editAddressPopup
  },
  methods: {
    getData() {
      this.$ajax('/iap-api/wan4/base/getSelfDefinedDataCache.do', { tempId: this.$route.query.tempId }).then(res => {
        this.myData = res.data;
        if (!this.selectId) {
          this.selectId = res.data.res && res.data.res.addr && res.data.res.addr.seq || ''
        }
      })
      this.$ajax('/iap-api/wan4/addressbook/query.do', { seq: 0 }).then(res => {
        this.list = res.data || [];
      })
    },
    del(item, index) {
      this.$dialog.confirm({
        message: `确定 <span style='font-weight: bold;'>删除收货地址</span> 吗?`
      }).then(() => {
        this.$ajax('/iap-api/wan4/addressbook/del.do', { seq: item.seq }).then(() => {
          if (item.dflag == 1) {
            this.getData()
          } else {
            this.list.splice(index, 1);
          }
        })
      }).catch(() => {
      });
    },
    setAddress() {
      if (!this.selectId) {
        this.$toastUtil.show('请选择地址')
        return
      }
      this.myData.res.addr = this.list.filter(e => e.seq == this.selectId)[0];
      this.$ajax('/iap-api/wan4/base/setSelfDefinedDataCache.do', { tempId: this.$route.query.tempId, myData: this.myData }).then(() => {
        this.$router.back();
      })
    },
    edit(item) {
      item.daddr = item.daddr + item.daddr2;
      this.editItem = item;
      this.showEditAddress = true;
    },
  }
}
</script>

<style scoped lang="less">
.select-address {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: 100%;
  overflow: scroll;
  margin-bottom: calc(env(safe-area-inset-bottom) + 145px);

  >* {
    flex-shrink: 0;
  }

  .line {
    width: 100vw;
    height: 1px;
    background: #DCDCDC;
    position: fixed;
    top: 88px;
  }

  .item-box {
    display: flex;
    flex-direction: column;
    margin: 0 32px;
    padding: 32px 50px 24px 58px;
    position: relative;

    &::after {
      position: absolute;
      bottom: -1px;
      right: 0;
      left: 0;
      content: '';
      height: 1px;
      background: #E5E6EB;
    }

    .name {
      color: #333;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: 44px;
    }

    .address {
      color: #666;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
      margin-top: 10px;
      word-break: break-all;
      margin-right: 50px;
    }

    .icon-edit {
      position: absolute;
      right: -28px;
      width: 94px;
      height: 94px;
      font-size: 0;
      top: 50%;
      transform: translateY(-50%);
      background: url('https://xhdata.wan4.com/wsw-h5-40.png') no-repeat center;
      background-size: 38px 38px;
    }

    .selelct-box {
      position: absolute;
      top: 0;
      left: -32px;
      font-size: 0;
      width: 90px;
      height: 112px;
      display: flex;
      align-items: center;
      justify-content: center;

      &::after {
        content: '';
        width: 34px;
        height: 34px;
        border: 2px solid #999;
        border-radius: 34px;
      }

      &-on {
        &::after {
          content: '';
          width: 38px;
          height: 38px;
          border: none;
          border-radius: 38px;
          background: url('https://xhdata.wan4.com/wsw-h5-21.png') no-repeat center;
          background-size: 100%;
        }
      }
    }


    .default-opt {
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      display: flex;
      align-items: center;
      margin: 10px 0 0;
      color: #FF6634;

    }
  }

  .add-btn {
    color: #FF6634;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    margin: 0 32px;

    >i {
      width: 36px;
      height: 36px;
      background: url('https://xhdata.wan4.com/wsw-h5-34.png') no-repeat center;
      background-size: 100%;
      margin-right: 12px;
    }
  }

  .bottom-btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 16px 0;
    padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
    display: flex;
    box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.12);

    .van-button {
      margin: auto 24px;
      width: 100%;
      border-radius: 8px;
      font-size: 34px;
      font-weight: bold;
      color: #fff;
      height: 88px;
    }
  }

}
</style>
